import { api } from '../middleware/api';

export interface AmPurchaseDetail {
  pd_id?: number;
  pd_srid?: number;
  pd_name: string;
  pd_product?: number | null;
  pd_category: number | null;
  pd_code: string;
  pd_qty: number;
  pd_rate: number;
  pd_amount: number;
  pd_department?: number | null;
  pd_photos?: { ed_id: number }[];
  pd_location?: string;
  pd_serialno?: string;
  pd_depmethod?: string;
  pd_deprate?: number;
  pd_usefullife?: number;
  pd_salvagevalue?: number;
  pd_wr_enabled?: '0' | '1';
  pd_wr_supplier?: number;
  pd_wr_startdate?: string | null;
  pd_wr_enddate?: string | null;
  pd_wr_terms?: string;
  pd_in_enabled?: '0' | '1';
  pd_in_supplier?: number;
  pd_in_policyno?: string;
  pd_in_startdate?: string | null;
  pd_in_enddate?: string | null;
  pd_in_premium?: number;
  pd_in_suminsured?: number;
  pd_ac_enabled?: '0' | '1';
  pd_ac_supplier?: number;
  pd_ac_contractno?: string;
  pd_ac_startdate?: string | null;
  pd_ac_enddate?: string | null;
  pd_ac_value?: number;
  pd_ac_frequency?: string;
  pd_ac_coverage?: string;
}

export interface AmPurchaseMode {
  pm_id?: number;
  pm_srid?: number;
  pm_mode: number;
  pm_refno?: string;
  pm_refdt?: string | null;
  pm_bank?: string;
  pm_amt: number;
}

export interface AmPurchase {
  ap_id?: number;
  ap_company?: string;
  ap_date: string | null;
  ap_supplier: number | null;
  ap_invoiceno: string | null;
  ap_amount: number;
  ap_type: 'New' | 'Replacement' | 'Upgrade' | 'Additional';
  ap_notes: string | null;
  ap_active: '0' | '1';
  ap_details: AmPurchaseDetail[];
  ap_modes: AmPurchaseMode[];
  sp_name?: string;
}

export const ampurchaseApi = api
  .enhanceEndpoints({ addTagTypes: ['AmPurchase'] })
  .injectEndpoints({
    endpoints: builder => ({
      getAmPurchases: builder.query<AmPurchase[], string>({
        query: (company) => `ampurchase?company=${company}`,
        providesTags: ['AmPurchase']
      }),
      getAmPurchasesByAsset: builder.query<AmPurchase[], number>({
        query: (assetId) => `ampurchase/asset/${assetId}`,
        providesTags: ['AmPurchase']
      }),
      getAmPurchase: builder.query<AmPurchase, string>({
        query: (id) => `ampurchase/byid/${id}`,
        providesTags: ['AmPurchase']
      }),
      insertAmPurchase: builder.mutation<{ ap_id: number; ap_lines?: { pd_srid: number; pd_code: string }[]; ap_renamed?: { from: string; to: string }[] }, AmPurchase>({
        query: (body) => ({
          url: 'ampurchase',
          method: 'POST',
          body
        }),
        invalidatesTags: ['AmPurchase']
      }),
      updateAmPurchase: builder.mutation<{ ap_id: number; ap_lines?: { pd_srid: number; pd_code: string }[]; ap_renamed?: { from: string; to: string }[] }, AmPurchase>({
        query: (body) => ({
          url: 'ampurchase',
          method: 'PUT',
          body
        }),
        invalidatesTags: ['AmPurchase']
      }),
      deleteAmPurchase: builder.mutation<{ message: string }, string>({
        query: (id) => ({
          url: `ampurchase/${id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['AmPurchase']
      })
    }),
    overrideExisting: false
  });

export const {
  useGetAmPurchasesQuery,
  useGetAmPurchasesByAssetQuery,
  useGetAmPurchaseQuery,
  useInsertAmPurchaseMutation,
  useUpdateAmPurchaseMutation,
  useDeleteAmPurchaseMutation
} = ampurchaseApi;
